<template>
  <div class="in-passWordChange">
    <el-dropdown>
      <div class="el-dropdown-link">
        文件下载
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="exportPDF">操作手册</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  methods: {
    exportPDF() {
      let _this = this;
      // var params = new URLSearchParams();
      // params = {
      //     searchData: _this.$EcSearchUtils.searchFormat(_this.searchProps)
      // };
      _this.Api.operationManualExportPDF();
    }
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/EcHeaderDownload.vue